/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {knotSwitchCard} from '../api'

export const useMutationKnotSwitchCard = createReactQueryMutationHook('knotSwitchCard', knotSwitchCard)
